import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadDataSourceProfiling';
const loadProfilingDataSourcesArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['items'],
    loadResource: (inputPayload) => {
        return DataSourceResource.triggerDataProfiling(inputPayload.workspaceId, inputPayload.dataSourceProfiling);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadProfilingDataSourcesEpicReducer = loadResourcesUtils(loadProfilingDataSourcesArgs);
// Reducer
export const dataSourceProfilingReducer = (state = defaultReducerState, action) => {
    state = loadProfilingDataSourcesEpicReducer.reduxChange(state, action);
    return state;
};
export default dataSourceProfilingReducer;

//# sourceMappingURL=DataSourceProfiling.ducks.js.map
